export var ChartType = {
    Bar: "Bar",
    Pie: "Pie"
};
export var ImagePosition = {
    Left: "Left",
    Right: "Right"
};
export var Locale = {
    En: "en"
};
export var QuickNavigationIcons = {
    Check: "check",
    Contact: "contact",
    Download: "download",
    Events: "events",
    Faq: "faq",
    Profile: "profile"
};
export var BlogListQuery = "BlogList:dfb3567302c3562e72bbfc62d0b1410385716d652e25fc7ffbba303c268b3bd3";
export var EventListQuery = "EventList:eb92122246e0ccd77a90ec3053d18720d525eda3dd5a22334cab71294f9b2cc4";
export var OneClickFeedbackMutation = "OneClickFeedback:99319b6db3f90caa2605950603b5f0e98eb8f219576cece6b542e31bfaa827a7";
export var PreviewBlogQuery = "PreviewBlog:9913a09ef33bd658093245f261fb5e37841af6042a8ed4aff10b436e4ecda723";
export var PreviewLandingPageQuery = "PreviewLandingPage:b07e032bca6ef8c39ba78fd2d74e9c2733eab9affad3bef2a96fd47199d2c171";
export var PreviewPageQuery = "PreviewPage:725dde68e5a897f8a6c0b98d7cf4226a45a98650178564b6df863dbedbdbf37b";
export var PreviewTeamQuery = "PreviewTeam:22eda5bd5d88c44faf653ba792bdf94301575bae4d86ceab64dd4541d2639204";
export var TeamListQuery = "TeamList:f86bb0f7286e654c5217c3c216144771e621d994e00e39f1b3550987f492238d";
